var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      attrs: {
        errors: _vm.errors,
        guest: _vm.guest,
        child: _vm.child,
        bgGradient: "",
        location: _vm.location,
        programInquiry: _vm.program.title,
        breadcrumbs: _vm.guest
          ? ["Get Started", "Programs", "Summer Camps"]
          : ["Explore", "Summer Camps"],
      },
      scopedSlots: _vm._u([
        {
          key: "toggleFilter",
          fn: function () {
            return [
              _vm.shoppingCartItems
                ? _c(
                    "v-btn",
                    {
                      attrs: { icon: "", outlined: "", color: "white" },
                      on: {
                        click: function ($event) {
                          _vm.$inertia.visit(_vm.route("checkout.show"))
                        },
                      },
                    },
                    [
                      _c(
                        "v-badge",
                        {
                          attrs: {
                            content: _vm.shoppingCartItems,
                            color: "secondary",
                            overlap: "",
                            bordered: "",
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("shopping_cart"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-col",
        {
          staticClass: "white--text text-center px-0 form-width",
          attrs: { cols: "12", lg: "6" },
        },
        [
          _c("EventRegistrationSearch", {
            attrs: {
              errors: _vm.errors,
              program: _vm.program,
              location: _vm.location,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }